<template>
  <div>
    <div v-if="type === 1">
      <div class="image-grid">
        <img v-for="(image, i) in images" :key="i" :src="image.url" @click="onClick(i)" class="image"
          :alt="`Image ${i + 1}`" />
      </div>
      <vue-gallery-slideshow :images="images.map((img) => img.url)" :index="index" @close="index = null" />
    </div>

    <div v-if="type === 2">
      <div class="document-list">
        <div v-for="(files, docName) in groupedFiles" :key="docName" class="file-group">
          <div class="header">{{ docName }}</div>
          <div>
            <div v-for="(file, i) in files" :key="i">
              <a 
                v-if="!isImage(file.fileName)" 
                :href="file.url"
                target="_blank"
                class="file-item">
                {{ file.fileName }}
              </a>
            </div>
          </div>
          <div class="file-content">
            <div v-for="(file, i) in files" :key="i">
              <img 
                v-if="isImage(file.fileName)"  
                :src="file.url" 
                @click="onGroupedImageClick(docName, getImageIndex(files, i))" 
                class="image"
                :alt="`Document Image ${getImageIndex(files, i) + 1}`" 
              />
            </div>
          </div>
          <vue-gallery-slideshow 
            :images="getDocumentImages(files)"
            :index="docImageIndex[docName]" 
            @close="docImageIndex[docName] = null" 
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  name: "StageImage",
  components: {
    VueGallerySlideshow,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
    images: {
      type: Array,
      default: () => [],
    },
    otherFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      index: null,
      docImageIndex: {},
    };
  },
  computed: {
    imageFiles() {
      return this.otherFiles.filter((file) => this.isImage(file.fileName));
    },
    groupedFiles() {
      return this.otherFiles.reduce((groups, file) => {
        if (!groups[file.docName]) {
          groups[file.docName] = [];
        }
        groups[file.docName].push(file);
        return groups;
      }, {});
    },
  },
  methods: {
    onClick(i) {
      this.index = i;
    },
    onGroupedImageClick(docName, i) {
      this.$set(this.docImageIndex, docName, i);
    },
    isImage(fileName) {
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
      const extension = fileName.split(".").pop().toLowerCase();
      return imageExtensions.includes(extension);
    },
    getDocumentImages(files) {
      return files.filter(file => this.isImage(file.fileName)).map(file => file.url);
    },
    getImageIndex(files, currentIndex) {
      return files.filter((file, index) => this.isImage(file.fileName) && index < currentIndex).length;
    },
  },
};
</script>

<style>
.image {
  width: 130px !important;
  height: 130px !important;
  background-size: cover;
  border: 1px solid gray;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
}

.file-item {
  cursor: pointer;
  color: blue !important;
  margin: 5px;
  display: block !important;
}

.header {
  color: gray;
  font-weight: bold;
}
.file-content {
  display: flex;
  flex-wrap: wrap;
}

.vgs__gallery {
  display: none;
}

.vgs__container {
  height: auto !important;
}

.vgs {
  display: flex !important;
  align-items: center !important;
}
</style>
